export enum GamePhase {
  Waiting = 0,
  AddOptions = 1,
  SelectTemplate = 2,
  SelectOptions = 3,
  Watch = 4,
  Voting = 5,
  FinalReview = 6,
}
